import { Component, Input, OnInit } from '@angular/core';
import { IAccount } from '@app/interfaces';
import { IAdminModalComponent, IAdminModalData } from '../../domain/models/admin-modal';
import { AdminAccountsService } from '../../services';

@Component({
	selector: 'app-admin-permissions-modal',
	templateUrl: './admin-permissions-modal.component.html',
	styleUrls: ['./admin-permissions-modal.component.scss'],
})
export class AdminPermissionsModalComponent implements IAdminModalComponent, OnInit {
	@Input() data: IAdminModalData<{}>;
	permissions: {};
	isPermissionsLoading = false;
	constructor(private adminAccountsService: AdminAccountsService) {}
	ngOnInit() {
		const account = this.data.options as IAccount;
		this.isPermissionsLoading = true;
		this.adminAccountsService.getAdminAccountPermissions(account.account_uuid).subscribe({
			next: (res) => (this.permissions = res.permissions),
			complete: () => (this.isPermissionsLoading = false),
		});
	}

	closeEvent(e?: {}): void {}
}
